import { useMemo, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveIcon from '@mui/icons-material/Remove';
import { statsOf } from '../logic';
import BucketCard, { GrowthPill } from './BucketCard';

/** Score 0: collapsed by default - visible, but out of the way of the bullish/bearish buckets. */
export default function NeutralStrip({ rows, live = false }) {
  const [open, setOpen] = useState(false);
  const stats = useMemo(() => statsOf(rows), [rows]);
  if (!rows.length) return null;

  return (
    <Accordion
      id="bucket-neutral"
      expanded={open}
      onChange={(_, v) => setOpen(v)}
      disableGutters
      sx={{ scrollMarginTop: 96, '&::before': { display: 'none' } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1, mr: 1, minWidth: 0 }}>
          <Box sx={{ width: 32, height: 32, borderRadius: 2, display: 'grid', placeItems: 'center', bgcolor: (t) => alpha(t.palette.text.secondary, 0.12), color: 'text.secondary' }}>
            <RemoveIcon fontSize="small" />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontWeight: 700 }}>Neutral</Typography>
            <Typography variant="caption" color="text.secondary">
              {stats.count} symbols with trend score 0 · ▲ {stats.advancers} ▼ {stats.decliners}
            </Typography>
          </Box>
          <GrowthPill value={stats.avgGrowth} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: { xs: 1, sm: 2 }, pt: 0 }}>
        <BucketCard score={0} rows={rows} live={live} />
      </AccordionDetails>
    </Accordion>
  );
}
